jQuery(function($) {
	var $html = $('html').removeClass('no-js');

	$html.deepLinks();
	$('form input[id^="your-name_"]').attr('autocomplete', 'chrome-off');

	// ADD ALL YOUR CUSTOM JS THINGS AFTER THIS LINE
	$.accessibility();
	$.polyfillMultiselects();
	$('.pagecreator_filter').filterTags();

	// ADD ALL YOUR CUSTOM JS THINGS AFTER THIS LINE
	if($('body').is('.error404')) {
		setTimeout(function() {
			$html.addClass('break');
		}, 1000);
	}

	/**
	 * scrollspy addition to use element offset as reference
	 * @param $element
	 * @returns {number}
	 */
	$.elementOffset = function($element) {
		return $element.offset().top - $('.container-header').height();
	};

	/**
	 * Let each search-icon in navigation open the search toolbar
	 */
	$html.on({
		click: function() {
			if($html.is('[data-active="search"]')) {
				$html.removeAttr('data-active');
			}
			else {
				$html.attr('data-active', "search");
				$('[type="search"]').get(0).focus();
			}

			return false;
		}
	}, 'a.icon__search');

	/**
	 * Reload cards placeholder element
	 */
	$html.on({
		ready: function() {
			var card = $(this).find('[data-slider]').get(0);

			if(card) {
				gridCards(card);
				$(this).find('[data-slider]').slider();
			}
		}
	}, '.pagecreator_posttypelist, .pagecreator_termlist');

	// on [cmd]+[g] add debug class to container-content
	let $content = $('.container-content');
	$(document).on('keydown', function(e) {
		if(e.key === 'g' && e.metaKey) {
			$content.toggleClass('debug');
			// add state to local storage
			sessionStorage.setItem('debug', $content.hasClass('debug'));

			return false;
		}
	});
	// check local storage for debug state
	if(sessionStorage.getItem('debug') === 'true') {
		$content.addClass('debug');
	}
});
